import React, { Component } from 'react';
import loader from '../../images/icons/Spinner.svg';
import styles from './Loader.module.scss';


function Loader() {
    return (
        <div className={styles.loader}>
            <img src={loader} className={styles.loader__img} alt="Loading ..." />
        </div>
    )
}

export default Loader;

